import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';

const SummaryBar = ({ cartItems }) => {
    const numberOfProducts = cartItems.length;
    const numberOfItems = cartItems.reduce((total, item) => total + item.qty, 0);
    const totalAmount = cartItems.reduce(
        (total, item) =>
            total + parseFloat(item.specialprice || item.price) * item.qty,
        0
    );

    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
          const offset = window.scrollY;
          const isMobile = window.innerWidth <= 768;
          const fallbackHeight = isMobile ? 400 : 850;
    
          const topHeader = document.querySelector(".marquee-container");
          const header = document.querySelector(".header-app-bar");
          const banner = document.querySelector(".banner-container");
    
          const threshold =
            (topHeader?.offsetHeight || 0) +
            (header?.offsetHeight || 0) +
            (banner?.offsetHeight || 0) ||
            fallbackHeight;
          
          if (offset > threshold) {
            setIsSticky(true);
          } else {
            setIsSticky(false);
          }
        };
    
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
      }, []);

    return (
        <Box
            className="summary-bar"
            style={{
                position: "sticky",
                top: 0,
                zIndex: 3,
                background: "#fff",
            }}
        >
            {/* Number of Products */}
            <Box
                className={`summary-box products ${isSticky ? 'summary-box-sticky' : ''}`}
            >
                <Typography variant="subtitle1" className={`summary-title ${isSticky ? 'summary-title-sticky' : ''}`}>
                    NUMBER OF PRODUCTS
                </Typography>
                <hr className="summary-divider" />
                <Typography variant="h4" className={`summary-value ${isSticky ? 'summary-value-sticky' : ''}`}>
                    {numberOfProducts}
                </Typography>
            </Box>

            {/* Number of Items */}
            <Box
                className={`summary-box items ${isSticky ? 'summary-box-sticky' : ''}`}
            >
                <Typography variant="subtitle1" className={`summary-title ${isSticky ? 'summary-title-sticky' : ''}`}>
                    NUMBER OF ITEMS
                </Typography>
                <hr className="summary-divider" />
                <Typography variant="h4" className={`summary-value ${isSticky ? 'summary-value-sticky' : ''}`}>
                    {numberOfItems}
                </Typography>
            </Box>

            {/* Total Amount */}
            <Box
                className={`summary-box amount ${isSticky ? 'summary-box-sticky' : ''}`}
            >
                <Typography variant="subtitle1" className={`summary-title ${isSticky ? 'summary-title-sticky' : ''}`}>
                    TOTAL AMOUNT
                </Typography>
                <hr className="summary-divider" />
                <Typography variant="h4" className={`summary-value ${isSticky ? 'summary-value-sticky' : ''}`}>
                    ₹{totalAmount.toFixed(2)}
                </Typography>
            </Box>
        </Box>
    );
};

export default SummaryBar;